export default {
  'dashboard.analysis.timeLabel': 'Thời gian',
  'dashboard.analysis.timeToday': 'Hôm nay',
  'dashboard.analysis.timeWeek': 'Tuần này', 
  'dashboard.analysis.timeMonth': 'Tháng này',
  'dashboard.analysis.timeYear': 'Năm này',
  'dashboard.analysis.operation1': 'Thao tác 1',
  'dashboard.analysis.operation2': 'Thao tác 2',
}